import { render, staticRenderFns } from "./PayPanel_Culinary.vue?vue&type=template&id=650599ba&scoped=true&"
import script from "./PayPanel_Culinary.vue?vue&type=script&lang=js&"
export * from "./PayPanel_Culinary.vue?vue&type=script&lang=js&"
import style0 from "./PayPanel_Culinary.vue?vue&type=style&index=0&id=650599ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650599ba",
  null
  
)

export default component.exports